import React from 'react';
import {
    Box,
    Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Paper,
    TextField
} from '@mui/material';

// Categories and their subcategories
const CATEGORY_OPTIONS = {
    'Catering': [
        'Full Service',
        'Buffet Style',
        'Food Truck',
        'Drop-off Service'
    ],
    'Entertainment': [
        'Live Band',
        'DJ',
        'Solo Performer',
        'Dance Group'
    ],
    'Decor': [
        'Full Venue Decoration',
        'Floral Arrangements',
        'Lighting',
        'Theme Decoration'
    ],
    'Photography': [
        'Event Photography',
        'Videography',
        'Photo Booth',
        'Drone Coverage'
    ],
    'Sponsor': [],
    'Other': []  // Empty array since we'll use text input
};

export const PackageDetailsStep = ({
    packageData,
    onFieldChange,
    errors,
    onNext
}) => {
    const handleCategoryChange = (event) => {
        const newCategory = event.target.value;
        onFieldChange('category', newCategory);
        
        // If category is Sponsor, skip to pricing step
        if (newCategory === 'Sponsor') {
            onFieldChange('pricingStrategy', 'sponsor_monetary');
            onNext();
            return;
        }
        
        // Reset subcategory and pricing strategy when category changes
        onFieldChange('subcategory', '');
        onFieldChange('pricingStrategy', '');
    };

    return (
        <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
            <Typography variant="h5" gutterBottom>
                Package Details
            </Typography>

            <Box sx={{ mt: 3 }}>
                <FormControl fullWidth error={Boolean(errors?.category)} sx={{ mb: 3 }}>
                    <InputLabel>Category</InputLabel>
                    <Select
                        value={packageData.category || ''}
                        label="Category"
                        onChange={handleCategoryChange}
                    >
                        {Object.keys(CATEGORY_OPTIONS).map((category) => (
                            <MenuItem key={category} value={category}>
                                {category}
                            </MenuItem>
                        ))}
                    </Select>
                    {errors?.category && (
                        <Typography color="error" variant="caption">
                            {errors.category}
                        </Typography>
                    )}
                </FormControl>

                {packageData.category && packageData.category !== 'Sponsor' && (
                    packageData.category === 'Other' ? (
                        // Show text field for custom subcategory when category is Other
                        <FormControl fullWidth error={Boolean(errors?.subcategory)}>
                            <TextField
                                label="Custom Category Type"
                                value={packageData.subcategory || ''}
                                onChange={(e) => onFieldChange('subcategory', e.target.value)}
                                error={Boolean(errors?.subcategory)}
                                helperText={errors?.subcategory || 'Please specify your category type'}
                            />
                        </FormControl>
                    ) : (
                        // Show dropdown for predefined subcategories
                        <FormControl fullWidth error={Boolean(errors?.subcategory)}>
                            <InputLabel>Subcategory</InputLabel>
                            <Select
                                value={packageData.subcategory || ''}
                                label="Subcategory"
                                onChange={(e) => onFieldChange('subcategory', e.target.value)}
                            >
                                {CATEGORY_OPTIONS[packageData.category].map((subcategory) => (
                                    <MenuItem key={subcategory} value={subcategory}>
                                        {subcategory}
                                    </MenuItem>
                                ))}
                            </Select>
                            {errors?.subcategory && (
                                <Typography color="error" variant="caption">
                                    {errors.subcategory}
                                </Typography>
                            )}
                        </FormControl>
                    )
                )}
            </Box>
        </Paper>
    );
}; 

export default PackageDetailsStep;